import React from 'react';

import {LoadingSpinner} from '@newsela/angelou';
import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import {schoolSearchRoot} from 'static/three-oh/src/modules/constants/routePaths';

export const SCHOOL_SEARCH_PATH = [`${schoolSearchRoot}/:step?`];

const LazySchoolSearchComponent = Loadable({
  loader: () => import('./containers/SchoolSearchContainer'),
  loading: LoadingSpinner,
});

const SchoolSearchRoute = [
  <Route
    key="SchoolSearchCatchAll"
    path={SCHOOL_SEARCH_PATH}
    component={LazySchoolSearchComponent}
  />,
];

export default SchoolSearchRoute;
